import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { List } from 'immutable';
import moment from 'moment';
import cx from 'classnames';
import { Link } from 'react-router-dom';

const propTypes = {
  releases: PropTypes.instanceOf(List).isRequired,
};

const defaultProps = {
};

class PressReleases extends Component {
  constructor(props) {
    super(props);
    this.expand = this.expand.bind(this);
    this.collapse = this.collapse.bind(this);
    this.state = {
      expanded: false,
    };
  }

  expand(event) {
    event.preventDefault();
    event.stopPropagation();

    this.setState({ expanded: !this.state.expanded });
  }

  collapse(event) {
    event.preventDefault();
    event.stopPropagation();

    this.setState({ expanded: false });
  }

  url(release) {
    return `/about/releases/${release.slug || release.date_posted}`;
  }

  render() {
    const { releases } = this.props;
    const releaseCards = releases.map(release => (
      <div key={`${release._id}`} className="col-sm-6 font-family-overpass padding-right-30">
        <div className="text-weight-bold text-size-sm-18 text-size-xs-16 padding-top-xs-10 padding-top-sm-0">
          <Link
            to={{ pathname: this.url(release) }}
            className="text-color-dark-slate"
          >{release.title}</Link>
        </div>
        <div className="text-weight-book text-size-sm-16 text-size-xs-14 padding-vertical-sm-20 padding-vertical-xs-10">
          {moment(`${release.date_posted}`).format('MMMM D, YYYY')}
        </div>
        <Link
          to={{ pathname: this.url(release) }}
          className="text-size-sm-18 text-size-xs-14 padding-vertical-sm-20 padding-vertical-xs-10"
        >Read more</Link>
        <hr className="padding-top-xs-10 padding-bottom-xs-10" />
      </div>
    )).toArray();

    const toggleClasses = cx({
      hidden: !this.state.expanded,
      visible: this.state.expanded,
    });
    const toggleButtonClasses = cx({
      hidden: this.state.expanded,
      visible: !this.state.expanded,
    });

    return (
      <div className="row">
        <div className="col-sm-10 col-sm-offset-1">
          <div className="text-left-sm text-center-xs">
            <div className="padding-top-sm-40 padding-bottom-sm-40 padding-top-xs-20 padding-bottom-xs-20 text-weight-black text-size-sm-42 text-size-xs-24 text-color-dark-slate">PRESS RELEASES</div>
          </div>
          <div className="row padding-bottom-xs-20">
            <div className="col-xs-12">
              {releaseCards.slice(0, 4)}
            </div>
          </div>
          { releaseCards.length > 4 &&
            <Fragment>
              <div className={`row text-center padding-top-sm-20 padding-bottom-xs-40 ${toggleButtonClasses}`}>
                <span onClick={this.expand} className="btn-alternate btn-bp">VIEW MORE</span>
              </div>
              <div className={toggleClasses}>
                {releaseCards.slice(4, releaseCards.length)}
                <div className="row text-center padding-top-sm-20 padding-top-xs-40 padding-bottom-xs-40">
                  <span onClick={this.collapse} className="btn-alternate btn-bp">SHOW LESS</span>
                </div>
              </div>
            </Fragment>
          }
        </div>
      </div>
    );
  }
}

PressReleases.propTypes = propTypes;
PressReleases.defaultProps = defaultProps;
export default PressReleases;
